import { render, staticRenderFns } from "./vendorreport.vue?vue&type=template&id=2fc24224&scoped=true&"
import script from "./vendorreport.vue?vue&type=script&lang=js&"
export * from "./vendorreport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fc24224",
  null
  
)

export default component.exports